import React from 'react';
import PropTypes from 'prop-types';
import AppFlexbox from '../../common/AppFlexbox';
import PrintDesignEditorProductSidebar from './PrintDesignEditorProductSidebar';
import PrintDesignEditorToolbar from './PrintDesignEditorToolbar';

const PrintDesignEditorSidebar = ({
  productIds,
  ecomExternalProducts,
  fkEcomStore,
  fkEcomVendor,
  canvasController,
  formState,
  setFormState,
  loading,
  printTemplateState,
  setPrintTemplateState,
  toolbarMenuState,
  setToolbarMenuState
}) => (
  <AppFlexbox
    style={{
      gap: 0,
      height: '100%',
      maxHeight: '100%',
      width: '100%',
      maxWidth: 350,
      overflow: 'hidden'
    }}
  >
    <PrintDesignEditorProductSidebar
      canvasController={canvasController}
      ecomExternalProducts={ecomExternalProducts}
      fkEcomStore={fkEcomStore}
      fkEcomVendor={fkEcomVendor}
      formState={formState}
      loading={loading}
      printTemplateState={printTemplateState}
      productIds={productIds}
      setFormState={setFormState}
      setPrintTemplateState={setPrintTemplateState}
    />

    <PrintDesignEditorToolbar
      canvasController={canvasController}
      ecomExternalProducts={ecomExternalProducts}
      fkEcomStore={fkEcomStore}
      fkEcomVendor={fkEcomVendor}
      formState={formState}
      loading={loading}
      printTemplateState={printTemplateState}
      setFormState={setFormState}
      setPrintTemplateState={setPrintTemplateState}
      setToolbarMenuState={setToolbarMenuState}
      toolbarMenuState={toolbarMenuState}
    />
  </AppFlexbox>
);

PrintDesignEditorSidebar.propTypes = {
  canvasController: PropTypes.object.isRequired,
  ecomExternalProducts: PropTypes.array.isRequired,
  formState: PropTypes.object.isRequired,
  printTemplateState: PropTypes.object.isRequired,
  setFormState: PropTypes.func.isRequired,
  setPrintTemplateState: PropTypes.func.isRequired,
  setToolbarMenuState: PropTypes.func.isRequired,
  toolbarMenuState: PropTypes.object.isRequired,
  fkEcomStore: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  fkEcomVendor: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  loading: PropTypes.bool,
  productIds: PropTypes.array
};

export default PrintDesignEditorSidebar;
